import { render } from "./PpcV2MoreFilters.vue?vue&type=template&id=3266f522"
import script from "./PpcV2MoreFilters.vue?vue&type=script&lang=js"
export * from "./PpcV2MoreFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__